import {AbstractModel} from './abstract-model';
import {Document} from './document';
import {CompanyRole} from '../constants/company-role';
import {Civility} from '../constants/civility';

export class PartnerContact extends AbstractModel {
  id: number | null = null;
  partnerId: number | null = null;
  companyRole!: CompanyRole;
  civility: Civility | null = null;
  firstname: string | null = null;
  lastname: string | null = null;
  nickname: string | null = null;
  email: string | null = null;
  phoneNumber: string | null = null;
  telegram: string | null = null;
  teams: string | null = null;
  document: Document | null = null;
}
